import { createRoot } from "react-dom/client";
import React from "react";
import App from "./App";
import "./style.css";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(<App />);
